module.exports = __webpack_public_path__ + "img/radiaIcon2.fce07af9.png";